import { combineReducers } from 'redux';
import sessionReducer from './Intitiatesessionreducer';
import completesessionReducer from './Completesessionreducer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './UserReducer';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['session', 'completesession', 'userSession'],
};


const rootReducer = combineReducers({
  session: sessionReducer,
  completesession: completesessionReducer,
  userSession: userReducer
});


export default persistReducer(persistConfig, rootReducer);
